import { NavMarker } from 'react-rhumb';
import { Metrics } from 'email-management-lib/Shared/utils/metrics';
import { useEffect } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export default function SuccessMarker() {
  useEffect(() => {
    Metrics.timer('framework-success').update(performance.now());
  }, []);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: "TABLE_DATA_LOADED"
  });
}